export const docsLinks = {
	gettingStarted: {
		js: "https://www.rivet.dev/docs/clients/javascript/",
		react: "https://www.rivet.dev/docs/clients/react/",
		nextjs: "https://www.rivet.dev/docs/clients/next-js/",
	},
	runners: "https://www.rivet.dev/docs/self-hosting/connect-backend",
	quickstart: {
		backend: "https://www.rivet.dev/docs/actors/quickstart/backend",
		react: "https://www.rivet.dev/docs/actors/quickstart/react",
		nextjs: "https://www.rivet.dev/docs/actors/quickstart/next-js",
	},
	runtimeModes: "https://www.rivet.dev/docs/general/runtime-modes/",
	runnersSetup: "https://www.rivet.dev/docs/connect/",
};
